module.exports = __webpack_public_path__ + "img/update.c6b70f56.png";